import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../config/api';

function About() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        console.log('Fetching clients from API...');
        const response = await api.get('/clients');
        console.log('Clients API Response:', response);
        const data = response.data;
        console.log('Clients Data:', data);

        if (data.success && Array.isArray(data.data)) {
          console.log('Clients found:', data.data.length);
          console.log('All client data:', data.data);
          console.log('Client logos:', data.data.map(c => ({ id: c.id, name: c.name, logo: c.logo })));
          setClients(data.data);
        } else {
          console.warn('No clients data or invalid format:', data);
          setClients([]);
        }
      } catch (error) {
        console.error('Error fetching clients:', error);
        if (error.response) {
          console.error('Response status:', error.response.status);
          console.error('Response data:', error.response.data);
        } else if (error.request) {
          console.error('No response received. Request:', error.request);
          console.error('API URL might be incorrect or backend is not running');
        } else {
          console.error('Error setting up request:', error.message);
        }
        setClients([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []);
  return (
    <>
      <section className="page-banner bg-blue rel z-1" style={{backgroundImage: 'url(/assets/images/background/banner-bg.png)'}}>
        <div className="container">
          <div className="banner-inner">
            <h1 className="page-title wow fadeInUp delay-0-2s">About us</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active">about us</li>
              </ol>
            </nav>
          </div>
        </div>
        <img className="dots-shape" src="/assets/images/shapes/white-dots-two.png" alt="Shape" />
        <img className="tringle-shape slideLeftRight" src="/assets/images/shapes/white-tringle.png" alt="Shape" />
        <img className="close-shape" src="/assets/images/shapes/white-close.png" alt="Shape" />
        <img src="/assets/images/newsletter/circle.png" alt="shape" className="banner-circle slideUpRight" />
        <img className="dots-shape-three slideUpDown delay-1-5s" src="/assets/images/shapes/white-dots-three.png" alt="Shape" />
      </section>

      <section className="about-page-section rel z-1 pt-130 rpt-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-7 col-lg-7">
              <div className="about-page-content rmb-65 wow fadeInLeft delay-0-2s">
                <div className="section-title mb-25">
                  <span className="sub-title">Who we are</span>
                  <h2>We Are Professional and Creative CRM Solution Providers</h2>
                </div>
                <p className="text-justify">
                  Acuit CRM is a robust, self-hosted Customer Relationship Management system designed to empower small businesses, freelancers, startups, and growing agencies. With its all-in-one platform, Acuit CRM seamlessly integrates client management, project tracking, invoicing, sales pipeline management, support ticketing, and business analytics—allowing organizations to run their entire business from a single dashboard.
                </p>
                <p className="text-justify">
                  Built for scalability, security, and customization, Acuit CRM offers companies the flexibility to tailor the system to their workflows while maintaining complete ownership of their data. Whether you're managing clients, handling projects, or generating invoices, Acuit CRM provides the tools necessary to boost productivity, streamline operations, and improve business performance.
                </p>
                <p className="text-justify">
                  AcuIT(Owned by Plenitude IT) offers a common technology platform, covering sales, customer service and operations, for small to medium businesses, to implement data driven standard processes that improve productivity and help businesses scale.
                </p>
                <p className="text-justify">
                  Along with the generic automation software that serves the majority of small to medium businesses, Our CRM for Industries offers preconfigured solutions, helping customers to immediately benefit from the proven best practices, with enterprise level support.
                </p>
                <p className="text-justify">
                  Our expertised developers and designers will create the best solution as per the market standards. We have successfully done several projects in CRM Development by understanding every detail of the client's business requirement. We are the Professional CRM Development Company in Sungai Petani, Malaysia among Top Development Companies.
                </p>
                <ul className="list-style-one mt-30 mb-45">
                  <li>30-day free trial of our premium plan</li>
                  <li>Free Demo</li>
                  <li>Lifetime Upgrade</li>
                </ul>
                <Link to="/contact" className="theme-btn">Get Started <i className="fas fa-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5">
              <div className="justify-content-lg-end wow fadeInRight delay-0-2s">
                <img src="/my/Aboutus.png" alt="About Us" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="solutions-section-three rel z-1 pt-110 rpt-80 pb-75 rpb-45">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-3 col-md-6">
              <div className="solution-item-two wow fadeInUp delay-0-2s">
                <span className="number">01</span>
                <i className="fas fa-check"></i>
                <h4>Track your Customers</h4>
                <p>Our CRM software will help to track the sales leads from small and large businesses.</p>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="solution-item-two color-two wow fadeInUp delay-0-4s">
                <span className="number">02</span>
                <i className="fas fa-check"></i>
                <h4>Value for Money</h4>
                <p>Save at least 50% of CRM cost compared to other CRM solutions. Complete yet affordable CRM</p>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="solution-item-two color-three wow fadeInUp delay-0-6s">
                <span className="number">03</span>
                <i className="fas fa-check"></i>
                <h4>Excellent Support</h4>
                <p>We provide best customer service over phone & remote tools to ensure your CRM success</p>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="solution-item-two color-four wow fadeInUp delay-0-8s">
                <span className="number">04</span>
                <i className="fas fa-check"></i>
                <h4>Ready to Use</h4>
                <p>ACU IT CRM software is ready to use with all fields, forms and reports are pre-configured for small and medium businesses</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section bg-lighter rel z-1 mt-155 pb-75 rpb-45">
        <div className="container">
          <div className="counter-inner-two bg-blue bgs-cover text-white rel z-3" style={{backgroundImage: 'url(/assets/images/shapes/counter-bg.png)'}}>
            <div className="row">
              <div className="col-xl-4 col-md-6">
                <div className="success-item style-two wow fadeInUp delay-0-2s">
                  <i className="flaticon-market"></i>
                  <span className="count-text" data-speed="3000" data-stop="100">0</span>
                  <p>Project Completed</p>
                </div>
              </div>
              <div className="col-xl-4 col-md-6">
                <div className="success-item style-two wow fadeInUp delay-0-6s">
                  <i className="flaticon-trophy"></i>
                  <span className="count-text" data-speed="3000" data-stop="7">0</span>
                  <p>Year Experience</p>
                </div>
              </div>
              <div className="col-xl-4 col-md-6">
                <div className="success-item style-two wow fadeInUp delay-0-8s">
                  <i className="flaticon-group"></i>
                  <span className="count-text" data-speed="3000" data-stop="250">0</span>
                  <p>Happy Clients</p>
                </div>
              </div>
            </div>
            <div className="white-circle">
              <img src="/assets/images/shapes/white-circle.png" alt="White Circle" />
            </div>
          </div>
        </div>
      </section>

      <section className="clients-section bg-lighter rel z-1 pt-130 rpt-100 pb-130 rpb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10">
              <div className="section-title text-center mb-60 rmb-40">
                <span className="sub-title">Our Clients</span>
                <h2>Trusted by Leading Companies</h2>
                <p>We are proud to work with businesses of all sizes across various industries</p>
              </div>
            </div>
          </div>
          <div className="clients-grid">
            {loading ? (
              <div className="text-center w-100" style={{padding: '40px'}}>
                <p>Loading clients...</p>
              </div>
            ) : clients.length > 0 ? (
              clients.map((client, index) => {
                if (index === 0) {
                  console.log('Rendering', clients.length, 'clients in the grid');
                }
                return (
                <div 
                  key={client.id || index} 
                  className="client-logo-item wow fadeInUp" 
                  style={{animationDelay: `${index * 0.05}s`}}
                >
                  <div className="client-logo-card">
                    <div className="client-logo-wrapper">
                      {client.logo ? (
                        <img 
                          src={client.logo} 
                          alt={client.name || `Client ${client.id}`}
                          className="client-logo-img"
                          loading="lazy"
                          style={{
                            display: 'block',
                            maxWidth: '100%',
                            maxHeight: '80px',
                            width: 'auto',
                            height: 'auto',
                            objectFit: 'contain'
                          }}
                          onLoad={() => {
                            console.log('Successfully loaded client logo:', client.logo);
                          }}
                          onError={(e) => {
                            console.error('Failed to load client logo:', client.logo);
                            console.error('Client data:', client);
                            // Hide the broken image
                            e.target.style.display = 'none';
                            // Show placeholder if it doesn't exist
                            const wrapper = e.target.parentElement;
                            if (wrapper && !wrapper.querySelector('.client-logo-placeholder')) {
                              const placeholder = document.createElement('div');
                              placeholder.className = 'client-logo-placeholder';
                              placeholder.textContent = client.name || `Client ${client.id}`;
                              placeholder.style.cssText = 'color: #999; font-size: 14px; font-weight: 500; text-align: center; width: 100%;';
                              wrapper.appendChild(placeholder);
                            }
                          }}
                        />
                      ) : (
                        <div className="client-logo-placeholder">
                          {client.name || `Client ${client.id}`}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                );
              })
            ) : (
              <div className="text-center w-100" style={{padding: '40px'}}>
                <p>No clients available at the moment.</p>
                <p style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
                  Please check the browser console for more details.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default About;

